import {StyledProps, React, withStyles, classNames} from '@api'
import {DevDeploymentsMenu} from '@modules/pages'
import {CUSTOMER_LANDING_PAGE_IMAGE} from '@resources'
import {cc, configs, deployments, globalStores, site} from '@stores'
import { Login as LoginWidget } from './widget/Login'
import {observer} from 'mobx-react';
import * as css from './Login.css'
import { LoadingIndicator } from '@design-board'

const styles = (theme) => ({
  root: {
  }
})

interface MyProps extends StyledProps {
  onSubmit?: (e) => void,
  error?: {},
  onLoginSuccess?: (result, input) => void,
}

@(withStyles as any)(styles)
@observer
export class LoginComponent extends React.Component <MyProps> {
  render() {
    const {classes, onSubmit, error, onLoginSuccess} = this.props,
      {site: {loginConfig}} = globalStores

    const background = loginConfig?.background ?? (CUSTOMER_LANDING_PAGE_IMAGE[configs?.config?.loginPageBgImage] ? `url(${CUSTOMER_LANDING_PAGE_IMAGE[configs?.config?.loginPageBgImage]})` : 'url(/login-bg.jpg)')

    return (
      <div className={classNames(css.root, classes.root)} style={!background ? undefined : background.startsWith('url(') ? {backgroundImage: background} : {background}}>
        {DEBUG && <DevDeploymentsMenu/>}

        <LoginWidget key={deployments.selectedDeploymentId}
                     onSubmit={onSubmit} error={error} onLoginSuccess={onLoginSuccess}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/components/Login.tsx